(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
const initializeRpcHeaders = (scope) => {
  scope.querySelectorAll('.rpc-site-header').forEach((header) => {
    if (header.dataset.rpcInitialized === 'true') return;
    header.dataset.rpcInitialized = 'true';
    const menuButton = header.querySelector('[data-rpc-menu-button]');
    const nav = header.querySelector('[data-rpc-nav]');
    const dropdownButtons = header.querySelectorAll('[data-rpc-dropdown]');

    const closeDropdowns = (exception) => {
      dropdownButtons.forEach((button) => {
        if (button !== exception) {
          button.setAttribute('aria-expanded', 'false');
          button.closest('.rpc-header__menu-item--dropdown').classList.remove('is-open');
        }
      });
    };

    const closeMenu = () => {
      if (!menuButton || !nav) return;
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', menuButton.dataset.openLabel);
      nav.classList.remove('is-open');
      closeDropdowns();
    };

    if (menuButton && nav) {
      menuButton.addEventListener('click', () => {
        const opening = menuButton.getAttribute('aria-expanded') !== 'true';
        menuButton.setAttribute('aria-expanded', String(opening));
        menuButton.setAttribute('aria-label', opening ? menuButton.dataset.closeLabel : menuButton.dataset.openLabel);
        nav.classList.toggle('is-open', opening);
        if (!opening) closeDropdowns();
      });
    }

    dropdownButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const opening = button.getAttribute('aria-expanded') !== 'true';
        closeDropdowns(button);
        button.setAttribute('aria-expanded', String(opening));
        button.closest('.rpc-header__menu-item--dropdown').classList.toggle('is-open', opening);
      });
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) closeMenu();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 980) closeMenu();
    });
  });
};

document.addEventListener('DOMContentLoaded', () => initializeRpcHeaders(document));
document.addEventListener('shopify:section:load', (event) => initializeRpcHeaders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-quantity-change]');if(!button)return;const quantity=button.parentElement.querySelector('[data-quantity-input]');if(!quantity)return;const change=Number(button.dataset.quantityChange);const current=Number(quantity.value)||0;quantity.value=Math.max(0,current+change);quantity.dispatchEvent(new Event('change',{bubbles:true}))})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preview-products"] && !Shopify.designMode) return;
  try {
    
const initializeRpcProductRails = (scope) => {
  scope.querySelectorAll('.rpc-product-rail').forEach((rail) => {
    if (rail.dataset.rpcInitialized === 'true') return;
    rail.dataset.rpcInitialized = 'true';
    const track = rail.querySelector('[data-rpc-product-track]');
    const previous = rail.querySelector('[data-rpc-rail-previous]');
    const next = rail.querySelector('[data-rpc-rail-next]');
    if (!track || !previous || !next) return;

    const updateControls = () => {
      previous.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };

    const move = (direction) => {
      track.scrollBy({ left: direction * track.clientWidth * 0.84, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  });
};

document.addEventListener('DOMContentLoaded', () => initializeRpcProductRails(document));
document.addEventListener('shopify:section:load', (event) => initializeRpcProductRails(event.target));

  } catch(e) { console.error(e); }
})();
})();
